export const adminType = {
    SET_ERROR_FETCH: 'SET_ERROR_FETCH',
    SET_DATE_OF_REPORT: 'SET_DATE_OF_REPORT',
    SET_REPORT: 'SET_REPORT',
    SET_USERS: 'ADMIN/SET_USERS',
    SET_PAGE: 'ADMIN/SET_PAGE',
    SET_ROWS_PER_PAGE: 'ADMIN/SET_ROWS_PER_PAGE',
    SET_QUERY: 'ADMIN/SET_QUERY',
};
